import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DestructionTypesActions} from '../store';
import {DestructionTypesSelectors} from '../store/selectors';

@Injectable()
export class DestructionTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDestructionTypesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDestructionTypesDone(): Observable<boolean> {

    return this.store.pipe(
      select(DestructionTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DestructionTypesActions.ReadDestructionTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
